<template>
    <div data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column class="pa-4">
                <v-breadcrumbs class=" pl-0">
                    <v-icon slot="divider">
                        keyboard_arrow_left
                    </v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">
                                keyboard_arrow_left
                            </v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          mb-4
                >
                    <v-flex lg6>
                        <h1 class="section-title-main my-3 mr-4 font-weight-regular">
                            {{ $t("База знаний") }}
                        </h1>
                    </v-flex>
                    <v-flex lg6>
                        <inputIcon v-model="database_search" class="layout row search--no-border"
                                   icon_name="search"
                                   :placeholder="$t('Поиск по базе знаний')"
                        />
                    </v-flex>
                </v-layout>
                <v-layout column mb-4>
                    <v-tabs
                        v-model="tabs"
                        slot="extension"
                        color="white"
                        :slider-color="tabsColor"
                    >
                        <v-tab v-for="(tabHead, index) in accessed_tab_heads" :key="index" class="wrapper-relative"
                               :href="tabHead.href"
                        >
                            <v-layout row wrap align-center>
                                <v-flex md2>
                                    <svg v-svg
                                         :symbol="tabHead.icon"
                                         size="32 32"
                                         class="icon"
                                         role="presentation"
                                    />
                                </v-flex>
                                <v-flex sm12 xs12 md9
                                        :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                >
                                    {{ $t(tabHead.text) }}
                                </v-flex>
                            </v-layout>
                        </v-tab>
                        <v-tab-item
                            v-for="(tabItem, index) in accessed_tab_items"
                            :key="index"
                            :value="tabItem.value"
                        >
                            <component v-show="database_search.length == 0" class="py-5" :is="tabItem.component" />
                        </v-tab-item>
                    </v-tabs>
                    <div v-if="database_search && (search_results.list && search_results.list.length == 0)" class="mt-4">
                        {{ $t("По запросу ничего не найдено") }}
                    </div>
                    <searchBlock v-if="database_search && database_search.length>0" :content="search_results.list" />
                    <v-layout wrap class="my-4">
                        <buttonRed :class="{'xs12 flex': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL(improve_database_modal)">
                            {{ $t("Предложить улучшение базы знаний") }}
                        </buttonRed>
                        <buttonBdWhite :class="{'mt-3 xs12 flex': $vuetify.breakpoint.xs,'ml-4': $vuetify.breakpoint.smAndUp}" @click.native="OPEN_CONTACT_MODAL()">
                            {{ $t("Задать вопрос") }}
                        </buttonBdWhite>
                    </v-layout>
                </v-layout>
                <v-dialog :value="database_detail_modal.active" persistent content-class="scrolled-dialog">
                    <databaseModal v-if="database_detail_modal.active" />
                </v-dialog>
                <v-dialog :value="crosslink_detail_modal.active" persistent content-class="scrolled-dialog">
                    <innerDatabaseModal v-if="crosslink_detail_modal.active" />
                </v-dialog>
                <v-dialog :value="improve_database_modal.active" persistent content-class="scrolled-dialog">
                    <databaseImproveModal v-if="improve_database_modal.active" />
                </v-dialog>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import searchBlock   from '@/components/view_blocks/Database/list_blocks/search_block';
import databaseBlock from '@/components/blocks/news/news_page_item';
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import buttonRed   from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import classifications   from '@/components/view_blocks/Database/Database_classification';
import oem   from '@/components/view_blocks/Database/Database_oem';
import product   from '@/components/view_blocks/Database/Database_product';
import glossary   from '@/components/view_blocks/Database/Database_glossary';
import databaseModal from './Database_modals/Database_modal';
import innerDatabaseModal from './Database_modals/Database_inner_modal';
import databaseImproveModal from './Database_modals/Database_improve_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import REGION_CODES from '@/configs/region_codes';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    buttonBdWhite,
    databaseModal,
    databaseImproveModal,
    innerDatabaseModal,
    searchBlock,
  },
  data() {
    return {
      panel   : [],
      items   : 5,
      tabHeads: [],
      tabItems: [],
    };
  },
  computed: {
    accessed_tab_heads() {
      return this.tabHeads.filter((tabHead) => tabHead.permissions);
    },
    accessed_tab_items() {
      return this.tabItems.filter((tabItem) => tabItem.permissions);
    },
    ifNotSearch() {
      if (!this.search_results || !this.search_results.list || this.database_search.length == 0) {
        return true;
      }
    },
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('ideas_bank', [
      'ideas_bank_modal',
    ]),
    ...mapGetters('database/modal', [
      'current_detail',
      'database_detail_modal',
      'crosslink_detail_modal',
      'improve_database_modal',
      'improve_database_article',
    ]),
    ...mapGetters('database/breadcrumbs', [
      'breadcrumbs',
    ]),
    ...mapGetters('database/classification', [
      'list',
    ]),
    ...mapGetters('database', [
      'current_tab',
      'search',
      'search_results',
      'common_list',
    ]),
    tabs: {
      get() {
        return this.current_tab;
      },
      set($event) {
        this.SEARCH_DATABASE('');
        return this.SET_TAB($event);
      },
    },
    database_search: {
      get() {
        return this.search;
      },
      set($event) {
        if ($event!=='') {
          this.SEARCH_DATABASE($event.target.value);
          return this.search_database($event);
        }
        return $event.target.value;
      },
    },
    tabsColor() {
      if (this.tabs=='classification') {
        return '#e2173d';
      } else if (this.tabs=='oem') {
        return '#84a45d';
      } else if (this.tabs=='products') {
        return '#44b69e';
      } else if (this.tabs=='glossary') {
        return '#2755cf';
      }
    },
  },
  watch: {
    '$route'(to, from) {
      this.tabs = to.hash.slice(1);
    },
  },
  mounted() {
    this.SEARCH_DATABASE('');

    this.tabHeads = [
      {
        href       : '#classification',
        icon       : this.user.region_code !== REGION_CODES.BITUM_MATERIALS ? 'classifications' : 'oil-truck',
        text       : this.user.region_code !== REGION_CODES.BITUM_MATERIALS ? 'Международные классификации' : 'Методические материалы',
        permissions: true,
      },
      {
        href       : '#oem',
        icon       : 'accept-oem',
        text       : 'Спецификации OEM',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        href       : '#products',
        icon       : 'product-case',
        text       : 'Продуктовый портфель',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        href       : '#glossary',
        icon       : 'glossary',
        text       : 'Глоссарий',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];
    this.tabItems = [
      {
        value      : 'classification',
        component  : classifications,
        permissions: true,
      },
      {
        value      : 'oem',
        component  : oem,
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        value      : 'products',
        component  : product,
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        value      : 'glossary',
        component  : glossary,
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];

    setTimeout(() => {
      let modalId = parseInt(this.$route.query.modalId);
      const tab = this.$route.query.tab;

      if (!modalId && this.$route.hash) {
        let hash = this.$route.hash;
        hash = hash.replace(/\#[a-zA-Z]*\?/, '');
        hash = JSON.parse('{"' + decodeURI(hash).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

        if (hash.modalId) {
          modalId = hash.modalId;
        }
      }

      if (modalId) {
        this.SET_TAB(tab);
        this.SET_CURRENT({type: tab, id: modalId});
        this.OPEN_MODAL(this.database_detail_modal);
      }
    }, 1000);

    this.$nextTick(() => {
      if (this.$route.hash) {
        this.SET_TAB(this.$route.hash.slice(1));
      }
    });
  },
  methods: {
    ...mapMutations('contact/requests', [
      'OPEN_CONTACT_MODAL',
    ]),
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT',
    ]),
    ...mapMutations('database', [
      'SET_TAB',
      'SEARCH_DATABASE',
    ]),
    ...mapActions('database', [
      'search_database',
    ]),
  },
};
</script>
